<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :UseScrollable="false"
        :HideModalFun="onHidden"
        :TitleWindow="$t('PatientPortalDashboard.Dropdown.PrintLetter')"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Print'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col md="12">
                <MdSelect
                    ref="option2"
                    v-bind:Label="$t('insuranceSetup.Template')"
                    v-bind:Options="letterTemplateList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:ModelArray="valueTemplate"
                    v-bind:Multiple="false"
                    v-bind:AllowEmpty="false"
                    :Input="changeDropDownOption"
                    v-bind:isRequired="true"
                    v-bind:isValid="this.isTemplateValid"
                />
            </b-col>
        </b-row>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientPortalNotify',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCodeList: {
            type: Array,
            default: () => []
        },
        letterTemplateList: {
            Type: Array,
            default: () => []
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalLetterModal',
            emitCloseEvent: false,
            valueTemplate: null,
            isTemplateValid: true
        };
    },
    methods: {
        changeDropDownOption(item) {
            this.valueTemplate = item;
        },

        resetData() {
            this.valueTemplate = null;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.printMessage();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate_required() {
            this.isTemplateValid = this.valueTemplate ? true : false;
            return this.isTemplateValid;
        },

        printMessage() {},

        async sendNotificationMessage() {
            let params = {
                messageType: this.valueTemplate.messageType,
                notificationType: this.valueTemplate.notificationType.toUpperCase(),
                patientCodeList: this.patientCodeList
            };

            await PatientPortalsService.sendNotificationMessage(params)
                .then(response => {
                    if (response.status == '200') {
                        if (response.data.success) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('scheduleNotify.msgSent')
                            );
                            this.$emit('update:visible', false);
                            this.resetData();
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                response.data.errorMessage,
                                'error'
                            );
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
};
</script>
